import { first } from 'rxjs/operators';
import { TranslationDataStore } from './translation-data-store';

export async function fetchLocale(locale: string) {
    const { lang, message } = await TranslationDataStore.getInstance()
        .fetchOne(locale, true)
        .pipe(first())
        .toPromise();

    return { [lang]: { message } };
}
